module.exports = __webpack_public_path__ + "static/media/bambusheader.8e805334.png";